module.exports = __webpack_public_path__ + "static/media/3DPPA36.4ad7379b.jpg";